import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Form, FormProps, Modal, Select, TreeSelect } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { useToasts } from '../../contexts/toasts';
import { Categories } from '../../api/Categories';
import { DataNode } from 'antd/es/tree';

export interface PaletteFilters {
  categories?: string;
  status?: string;
  page?: number;
  search?: string;
  tags?: string[];
}

type Props = {
  show?: boolean;
  onClose?: () => void;
  onSubmit?: (filters: any) => void;
  selectedGroup?: string;
  filters?: PaletteFilters;
}

const formProps: FormProps = {
  layout: 'horizontal',
  colon: false,
  labelAlign: 'left',
  labelCol: {
    md: 8
  },
}

export default function PaletteFiltersModal({ show, onClose, selectedGroup = "services", filters, onSubmit }: Props) {
  const [form] = Form.useForm();
  const [categoriesOptions, setCategoriesOptions] = useState<DataNode[]>();

  const { showToast } = useToasts();

  useEffect(() => form.setFieldsValue(filters), [form, filters]);

  const initAreas = useCallback(() => {
    const params = new URLSearchParams([['populateHierarchy', 'true']]);

    Categories.getCategories(params)
      .then(
        ({ data }) => {
          setCategoriesOptions(data.map(category => ({
            key: category.id!,
            title: category.name,
            value: category.id!,
            children: category.children?.map(c => ({ key: c.id!, title: c.name, value: c.id!, isLeaf: !c.children?.length })),
            isLeaf: !category.children?.length,
          })));
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast('areas-error', message, `Areas Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }, [showToast]);

  useEffect(() => {
    if (show && selectedGroup === "services") {
      if (!categoriesOptions) initAreas();
    }
  }, [show, selectedGroup, initAreas, categoriesOptions]);

  const handleSubmit = useCallback((values: PaletteFilters) => onSubmit?.(values), [onSubmit]);

  const renderServiceFilters = useCallback(() => {
    return (
      <>
        <Form.Item name="categories" label="Categories">
          <TreeSelect
            allowClear
            loading={!categoriesOptions}
            placeholder="Select categories"
            treeData={categoriesOptions}
            treeNodeFilterProp="title"
            className="w-100"
            multiple
          />
        </Form.Item>
        <Form.Item name="tags" label="Tags">
          <Select mode="tags" placeholder="Select Tags" className="w-100" allowClear />
        </Form.Item>
      </>
    );
  }, [categoriesOptions]);

  return (
    <Modal
      open={show}
      onCancel={onClose}
      onClose={onClose}
      title={<h6 className="text-capitalize mb-3">{selectedGroup} filters</h6>}
      footer={null}
    >
      <Form {...formProps} form={form} onFinish={handleSubmit}>
        {selectedGroup === 'services' && renderServiceFilters()}

        <Flex justify="space-between" align="center">
          <Button variant="light" size="sm" className="border" onClick={onClose}>Close</Button>
          <Button variant="success" size="sm" type="submit">
            <FontAwesomeIcon icon={solid('search')} />
            <span className="ms-2">Search</span>
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}